// extracted by mini-css-extract-plugin
export default {"mangfoldstestResultPage":"MangfoldstestResultPage_mangfoldstestResultPage__SU8rS"};